// extracted by mini-css-extract-plugin
export default {"form":"registerForm_form__8tKcV","textField":"registerForm_textField__5fnW0"};